const preview = {
    namespaced: true,
    state: {
        categoryFields: {
            ACTIVITE: [],
            COMMERCE_ET_SERVICE: [],
            PRODUCTEUR: [],
            DOMAINE_SKIABLE_VTT: [],
            EQUIPEMENT: [],
            FETE_ET_MANIFESTATION: [],
            HEBERGEMENT_COLLECTIF: [],
            HEBERGEMENT_LOCATIF: [],
            HOTELLERIE: [],
            HOTELLERIE_PLEIN_AIR: [],
            PATRIMOINE_CULTUREL: [],
            PATRIMOINE_NATUREL: [],
            RESTAURATION: []
        }
    },
    mutations: {
        setCategoryFields(state, [code, fields]) {
            state.categoryFields[code] = fields
        }
    }
}

export default preview